<template>
    <div class="main-bg">
        <Nav></Nav>
        <div class="content">

            <div class="fix-nav" v-show="isfixTab">
                <div class="tabs">
                    <div class="item-tab"
                         v-for="(item, index) in tabs"
                         :key="index"
                         :class="{ active: currentTab === item.id }"
                         @click="tabChange(item.id)"
                         :is-scroll="false">
                        {{ item.name }}
                        <div class="actline" v-if="currentTab === item.id"></div>
                    </div>
                </div>
            </div>
            <div class="box">
                <template v-if="loading">
                    <skeletonDetail></skeletonDetail>
                </template>
                <template v-else-if="course" >
                 
                    <div class="nav">
        <a @click="$router.push({ name: 'home' })">首页</a> /
        <a @click="$router.push({ name: 'courses' })">在线课程</a> /
        <span>{{ course.title }}</span>
    </div>
                    <div class="course-info">
                        <div class="course-info-box">
                            <div class="course-thumb">
                                <thumbbar :value="course.thumb"
                                          :width="305"
                                          :height="172"></thumbbar>
                            </div>
                            <div class="info">
                                <div class="course-info-title">{{ course.title }}</div>
                                <div class="collect-button"
                                     :class="{ active: isCollect }"
                                     @click="collectCourse">
                                    <img v-if="isCollect"
                                         style="width:29px"
                                         src="../../../assets/course/favorite-h.png" />
                                    <img v-else
                                         style="width:29px"
                                         src="../../../assets/course/favorite-n.png" />
                                </div>
                                <p class="desc">{{ course.short_description }}</p>
                                <div class="btn-box">
                                    <template v-if="!isJoin">
                                        <div class="buy-button">
                                            加入课程
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="has-button">已加入</div>
                                    </template>

                                </div>
                            </div>
                        </div>


                        <div class="tabs" id="NavBar">
                            <div class="item-tab"
                                 v-for="(item, index) in tabs"
                                 :key="index"
                                 :class="{ active: currentTab === item.id }"
                                 @click="tabChange(item.id)"
                                 :is-scroll="false">
                                {{ item.name }}
                                <div class="actline" v-if="currentTab === item.id"></div>
                            </div>
                        </div>
                    </div>
                    <div class="coursr-desc" v-if="course" v-show="currentTab === 3">
                        <div class="u-content md-content"
                             v-html="course.render_desc"></div>
                    </div>
                    <div class="course-chapter-box" v-show="currentTab === 2">
                        <VideoChapterListComp :chapters="chapters"
                                              :course="course"
                                              :videos="videos"
                                              :isJoin="isJoin"
                                              v-if="chapters.length > 0"
                                              @switchVideo="goPlay"></VideoChapterListComp>
                        <VideoListComp :course="course"
                                       :videos="videos[0]"
                                       :isJoin="isJoin"
                                       @switchVideo="goPlay"
                                       v-else></VideoListComp>
                    </div>
                    <div class="course-comments-box" v-show="currentTab === 4">
                        <div class="comment-divider">全部评论</div>
                        <div class="line"></div>
                        <template>
                            <div class="replybox">
                                <div class="reply">
                                    <img class="user-avatar" src="https://exam.chinaopenschool.com:8080/api/app/file…load-file-system/978e39e183324e45ad912f3cc0928549" />
                                    <input type="text"
                                           class="reply-input"
                                           placeholder="此处填写你的评论"
                                           v-model="comment.content" />
                                    <div class="btn-submit"
                                         :class="{ active: comment.content.length > 0 }"
                                         @click="submitComment">
                                        评论
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="comment-top">
                            <template v-if="comments.length > 0">
                                <div class="comment-item"
                                     v-for="comment in comments"
                                     :key="comment.id">
                                    <div class="user-avatar">
                                        <img :src="comment.avatar" />
                                    </div>
                                    <div class="comment-content">
                                        <div class="comment-info">
                                            <div class="nickname">
                                                {{ comment.userName }}
                                            </div>
                                            <div class="comment-time">
                                                {{ comment.created_at }}
                                            </div>
                                        </div>

                                        <div class="comment-text"
                                             v-html="comment.content"></div>
                                    </div>
                                </div>
                            </template>
                            <none v-else type="white"></none>
                        </div>
                    </div>
                    <div class="attach-list-box" v-show="currentTab === 5">
                        <template v-if="attach.length > 0">
                            <div class="attach-item" v-for="item in attach" :key="item.id">
                                <div class="attach-name">{{ item.name }}</div>
                                <a @click="download(item.id)" class="download-attach">下载附件</a>
                            </div>
                        </template>
                        <none v-else type="white"></none>
                    </div>
                </template>
            </div>

        </div>
        </div>
</template>
<script>
    import Nav from "@/components/nav.vue";
    import None from "@/components/training/none.vue";
    import SkeletonDetail from "./components/skeletonDetail.vue";
    import VideoListComp from "./components/detail/video-list.vue";
    import VideoChapterListComp from "./components/detail/video-chapter-list.vue";
    import thumbbar from "@/components/training/thumb-bar.vue";
    export default {
        components: {
            Nav,
            None,
            SkeletonDetail,
            VideoListComp,
            VideoChapterListComp,
            thumbbar
        },
        data() {
            return {
                loading: false,
                id: this.$route.query.id,
                isCollect: false,
                course: {
                    "id": 33,
                    "title": "Uni-app实战视频点播小程序",
                    "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLA4Ec0CSWeQPYFhu6H3Dz8ZiaJ3zH9uicArhMYxvn5Z6icwqYPR8VoEGG9cvKcqZkNjiak/356",
                    "charge": 0,
                    "short_description": "全网最详细的Uniapp实战开发app小程序课程，7大实战开发案例（社区交友，商城，即时通讯，音频小说、网盘、点播、直播）帮助你获得技术优势并提高面试竞争力。",
                    "render_desc": "全网最详细的Uniapp实战开发app小程序课程，7大实战开发案例（社区交友，商城，即时通讯，音频小说、网盘、点播、直播）帮助你获得技术优势并提高面试竞争力",
                    "category_id": 4,
                    "user_count": 0,
                },
                attach: [],
                chapters: [
                    {
                        "id": 83,
                        "course_id": 33,
                        "title": "章节一：准备工作"
                    },
                    {
                        "id": 82,
                        "course_id": 33,
                        "title": "章节二：项目分析和全局样式"
                    },
                    {
                        "id": 97,
                        "course_id": 33,
                        "title": "章节三： 首页开发"
                    },
                    {
                        "id": 98,
                        "course_id": 33,
                        "title": "章节四：后端API开发"
                    }
                ],
                videos: {
                    "82": [
                        {
                            "id": 98,
                            "course_id": 33,
                            "title": "2-1 引入全局样式",
                            "view_num": 0,
                            "chapter_id": 82,
                            "duration": 109,
                        },
                        {
                            "id": 105,
                            "course_id": 33,
                            "title": "2-2 配置tabbar底部导航",
                            "view_num": 0,
                            "chapter_id": 82,
                            "duration": 109,
                        },
                        {
                            "id": 109,
                            "course_id": 33,
                            "title": "2-3 引入图标库",
                            "view_num": 0,
                            "chapter_id": 82,
                            "duration": 109,
                        }
                    ],
                    "83": [
                        {
                            "id": 97,
                            "course_id": 33,
                            "title": "1-1 环境搭建和项目创建",
                            "view_num": 0,
                            "chapter_id": 83,
                            "duration": 109,
                        }
                    ],
                    "97": [
                        {
                            "id": 110,
                            "course_id": 33,
                            "title": "3-1 导航栏配置",
                            "view_num": 0,
                            "chapter_id": 97,
                            "duration": 109,
                        },
                        {
                            "id": 129,
                            "course_id": 33,
                            "title": "3-2 轮播图组件",
                            "view_num": 0,
                            "chapter_id": 97,
                            "duration": 109,

                        },
                        {
                            "id": 130,
                            "course_id": 33,
                            "title": "3-3 全局列表组件开发",
                            "view_num": 0,
                            "chapter_id": 97,
                            "duration": 109,

                        }
                    ],
                    "98": [
                        {
                            "id": 131,
                            "course_id": 33,
                            "title": "4-1 数据表设计与迁移",
                            "view_num": 0,
                            "chapter_id": 98,
                            "duration": 109,

                        },
                        {
                            "id": 132,
                            "course_id": 33,
                            "title": "4-2 前后端数据交互",
                            "view_num": 0,
                            "chapter_id": 98,
                            "duration": 109,

                        }
                    ]
                },
                currentTab: parseInt(this.$route.query.tab || 2),
                nowTime: Date.parse(new Date()) / 1000,
     
                tabs: [
                    {
                        name: "课程目录",
                        id: 2,
                    },
                    {
                        name: "课程详情",
                        id: 3,
                    },

                    {
                        name: "课程评论",
                        id: 4,
                    },
                    {
                        name: "课程附件",
                        id: 5,
                    },
                ],

                isJoin: false,
                comments: [
                    {
                        "id": 39,
                        "userName": "管理员",
                        "avatar": "https://exam.chinaopenschool.com:8080//api/app/file/download-file-system/978e39e183324e45ad912f3cc0928549",
                        "content": "测试测试模拟评论",
                        "created_at": "2023-10-31 13:38:23"
                    }
                ],
                comment: {
                    content: "",
                },
                isfixTab: false,
            };
        },
        computed: {
        },
        mounted() {
            window.addEventListener("scroll", this.handleTabFix, true);
            this.getDetail();
            this.getComments();
        },
        beforeDestroy() {
            window.removeEventListener("scroll", this.handleTabFix, true);
        },
        methods: {

            //获取头像
            getAvatar(blobName) {
                if (blobName) {
                    let url = this.Link.split("#")[0];
                    sessionStorage.setItem("Link", url);
                    axios
                        .get(`${url}api/app/file/download-file-system/${blobName}`, {
                            responseType: "blob",
                        })
                        .then(({ data }) => {
                            let blob = new Blob([data]); // 返回的文件流数据
                            let url = window.URL.createObjectURL(blob); // 将他转化为路径
                            this.imgUrl = url; // 将转换出来的路径赋值给变量，其实和上一步结合就可以
                        });
                    this.$forceUpdate();
                }
            },
            handleTabFix() {
                let scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                let navbar = document.querySelector("#NavBar");
                if (navbar) {
                    let offsetTop = navbar.offsetTop;
                    scrollTop > offsetTop
                        ? (this.isfixTab = true)
                        : (this.isfixTab = false);
                }
            },
            tabChange(key) {
                this.currentTab = key;
            },
            goPlay(item) {

                this.$router.push({
                    name: "courseVideo",
                    query: {
                        id: item.id,
                    },
                });

            },
            download(id) {


            },
            getDetail() {
                if (this.loading) {
                    return;
                }
                this.loading = true;
                //Api.Detail(this.id)
                //  .then((res) => {
                //    this.loading = false;
                //    this.course = res.data.course;
                //    this.attach = res.data.attach;
                //    this.chapters = res.data.chapters;
                //      this.isJoin = res.data.isJoin;
                //    document.title = res.data.course.title;
                //    this.isCollect = res.data.isCollect;
                //    this.videoWatchedProgress = res.data.videoWatchedProgress;
                //    this.videos = res.data.videos;

                //  })
                //  .catch((e) => {
                //    this.$message.error("获取课程失败");
                //  });
                this.loading = false;
            },

            getComments() {
                if (this.comment.loading) {
                    return;
                }
                this.comment.loading = true;
                //Api.Comments(this.id)
                //  .then((res) => {
                //    this.comments = res.data.comments;
                //  })
                //  .catch((e) => {
                //    this.$message.error(e.message);
                //  });
            },
            collectCourse() {

                //Api.Collect(this.id)
                //  .then(() => {
                //    this.isCollect = !this.isCollect;
                //    if (this.isCollect) {
                //      this.$message.success("已收藏");
                //    } else {
                //      this.$message.success("取消收藏");
                //    }
                //  })
                //  .catch((e) => {
                //    this.$message.error(e.message);
                //  });

            },
            resetComments() {
                this.comment.loading = false;
                this.comment.content = "";
                this.comments = [];
            },
            submitComment() {
                if (this.comment.content.length === 0) {
                    return;
                }
                //Api.SubmitComment(this.id, this.comment)
                //  .then(() => {
                //    this.$message.success("成功");
                //    this.resetComments();
                //    this.getComments();
                //  })
                //  .catch((e) => {
                //    this.$message.error(e.message);
                //  });
            },
        },
    };
</script>
<style lang="scss" scoped>
    .main-bg {
        background-image: url("../../../assets/home/backougnd.png");
        background-size: cover;
        overflow-x: hidden;

        .content {
            width: 100%;
            padding-top: 86px;

            .fix-nav {
                width: 100%;
                background-color: #fff;
                position: sticky;
                top: 0;
                z-index: 50;

                .tabs {
                    width: 1200px;
                    margin: 0 auto;
                    height: 72px;
                    position: relative;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: row;
                    padding: 28px 30px;
                    border-radius: 0px 0px 8px 8px;

                    .item-tab {
                        min-width: 64px;
                        height: 16px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 16px;
                        margin-right: 80px;
                        cursor: pointer;
                        position: relative;

                        &.active {
                            font-weight: 600;
                            color: #3ca7fa;
                        }

                        .actline {
                            width: 52px;
                            height: 4px;
                            background: #3ca7fa;
                            position: absolute;
                            left: 6px;
                            top: 40px;
                        }
                    }
                }
            }

            .box {
                width: 1200px;
                margin: 0 auto;

                .nav {
                    width: 100%;
                    height: auto;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-items: center;
                    font-size: 14px;
                    color: #999999;
                    line-height: 14px;
                    margin-top: 30px;
                    margin-bottom: 30px;

                    a {
                        height: auto;
                        font-size: 14px;
                        font-weight: 400;
                        color: #999999;
                        line-height: 14px;
                        margin-right: 6px;
                        cursor: pointer;

                        &:not(:first-of-type) {
                            margin-left: 6px;
                        }
                    }

                    span {
                        flex: 1;
                        height: auto;
                        margin-left: 6px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 14px;
                        display: block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                .course-info {
                    width: 1200px;
                    height: auto;
                    background: #ffffff;
                    border-radius: 8px;

                    .course-info-box {
                        width: 1200px;
                        height: 300px;
                        box-sizing: border-box;
                        padding: 30px 50px 30px 30px;
                        position: relative;
                        display: flex;
                        flex-direction: row;

                        .course-thumb {
                            width: 320px;
                            height: 240px;
                            border-radius: 8px;
                            margin-right: 50px;
                            position: relative;
                            overflow: hidden;

                            .status {
                                position: absolute;
                                top: 10px;
                                left: 10px;
                                background-color: rgba(60, 167, 250);
                                color: #fff;
                                font-size: 14px;
                                padding: 4px;
                                border-radius: 4px;
                            }
                        }

                        .info {
                            width: 750px;
                            height: 240px;
                            position: relative;

                            .course-info-title {
                                width: 710px;
                                height: 30px;
                                font-size: 24px;
                                font-weight: 500;
                                color: #333333;
                                line-height: 24px;
                                margin-top: 20px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }

                            .collect-button {
                                width: 29px;
                                height: 29px;
                                position: absolute;
                                right: 0;
                                top: 18px;
                                cursor: pointer;
                            }

                            .desc {
                                margin-top: 14px;
                                width: 750px;
                                height: 90px;
                                font-size: 16px;
                                font-weight: 400;
                                color: #666666;
                                line-height: 30px;
                                overflow: hidden;
                            }

                            .btn-box {
                                position: absolute;
                                bottom: 0;
                                left: 0;
                                width: 100%;
                                height: auto;
                                float: left;
                                display: flex;
                                flex-direction: row;

                                .buy-button {
                                    background: #3ca7fa;
                                    border-radius: 4px;
                                    padding: 20px;
                                    font-size: 16px;
                                    font-weight: 400;
                                    color: #ffffff;
                                    line-height: 16px;
                                    box-sizing: border-box;
                                    cursor: pointer;

                                    &:hover {
                                        opacity: 0.8;
                                    }
                                }

                                .has-button {
                                    background: #f4fafe;
                                    border-radius: 4px;
                                    padding: 20px;
                                    font-size: 16px;
                                    font-weight: 400;
                                    color: #999999;
                                    line-height: 16px;
                                    box-sizing: border-box;
                                    cursor: pointer;
                                }
                            }
                        }
                    }

                    .tabs {
                        width: 1200px;
                        height: 72px;
                        position: relative;
                        box-sizing: border-box;
                        display: flex;
                        flex-direction: row;
                        padding: 28px 30px;

                        .item-tab {
                            min-width: 64px;
                            height: 16px;
                            font-size: 16px;
                            font-weight: 400;
                            color: #666666;
                            line-height: 16px;
                            margin-right: 80px;
                            cursor: pointer;
                            position: relative;

                            &.active {
                                font-weight: 600;
                                color: #3ca7fa;
                            }

                            .actline {
                                width: 52px;
                                height: 4px;
                                background: #3ca7fa;
                                position: absolute;
                                left: 6px;
                                top: 40px;
                            }
                        }
                    }
                }

                .course-teacher-box {
                    width: 1200px;
                    height: 270px;
                    background: #ffffff;
                    border-radius: 8px;
                    margin-top: 30px;
                    padding: 30px 50px;
                    box-sizing: border-box;

                    .teacher {
                        width: auto;
                        height: 80px;
                        display: flex;
                        align-items: center;
                        flex-direction: row;

                        .avatar {
                            width: 80px;
                            height: 80px;
                            border-radius: 50%;
                            margin-right: 20px;
                        }

                        a {
                            width: 100%;
                            height: 24px;
                            font-size: 24px;
                            font-weight: 600;
                            color: #333333;
                            line-height: 24px;
                        }
                    }

                    .teacher-desc {
                        margin-top: 26px;
                        width: 100%;
                        height: 64px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 32px;
                        overflow: hidden;
                    }
                }

                .coursr-desc {
                    padding: 30px;
                    background: #ffffff;
                    margin: 30px 0px;
                    border-radius: 8px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 30px;
                }

                .course-chapter-box {
                    width: 1200px;
                    padding: 50px 30px;
                    background: #ffffff;
                    margin: 30px 0px;
                    border-radius: 8px;
                }

                .course-comments-box {
                    width: 1200px;
                    box-sizing: border-box;
                    background: #ffffff;
                    margin: 30px 0px;
                    border-radius: 8px;
                    padding: 30px;

                    .comment-divider {
                        width: 100%;
                        height: 18px;
                        font-size: 18px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 18px;
                    }

                    .line {
                        width: 100%;
                        height: 1px;
                        background: #e5e5e5;
                        margin: 30px 0px;
                    }

                    .comment-top {
                        box-sizing: border-box;
                        width: 100%;
                        padding: 0;
                        display: flex;
                        flex-direction: column;

                        #page {
                            width: 100%;
                            display: flex;
                            justify-content: center;
                        }

                        .comment-item {
                            width: 100%;
                            display: flex;
                            flex-direction: row;
                            margin-bottom: 50px;

                            &:last-child {
                                margin-bottom: 0px;
                            }

                            .user-avatar {
                                width: 48px;
                                height: 48px;
                                background: #d8d8d8;
                                border-radius: 50%;
                                margin-right: 30px;

                                img {
                                    width: 48px;
                                    height: 48px;
                                    border-radius: 50%;
                                }
                            }

                            .comment-content {
                                width: 1062px;
                                display: flex;
                                flex-direction: column;

                                .comment-info {
                                    margin-top: 3px;
                                    display: flex;
                                    flex-direction: row;
                                    height: 14px;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #666666;
                                    line-height: 14px;
                                    margin-bottom: 16px;

                                    .nickname {
                                        margin-right: 15px;
                                    }
                                }

                                .comment-text {
                                    width: 1062px;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #333333;
                                    line-height: 20px;
                                    display: flex;
                                    flex-direction: row;
                                    flex-wrap: wrap;
                                }
                            }
                        }
                    }

                    .replybox {
                        box-sizing: border-box;
                        width: 100%;
                        height: 48px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-bottom: 50px;

                        .text {
                            width: 100%;
                            text-align: center;
                            cursor: pointer;

                            &:hover {
                                color: #3ca7fa;
                                text-decoration: underline;
                            }
                        }

                        .reply {
                            width: 100%;
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            .user-avatar {
                                width: 48px;
                                height: 48px;
                                background: #d8d8d8;
                                border-radius: 50%;
                                margin-right: 30px;
                            }

                            .reply-input {
                                width: 960px;
                                height: 48px;
                                border-radius: 4px;
                                border: 1px solid #cccccc;
                                padding-left: 10px;
                                margin-right: 30px;
                                outline: none;
                            }

                            .btn-submit {
                                width: 72px;
                                height: 48px;
                                background: #cccccc;
                                border-radius: 4px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 16px;
                                font-weight: 400;
                                color: #ffffff;
                                line-height: 16px;
                                cursor: pointer;

                                &:hover {
                                    opacity: 0.8;
                                }

                                &.active {
                                    background: #3ca7fa;
                                }
                            }
                        }
                    }
                }

                .attach-list-box {
                    width: 1200px;
                    display: flex;
                    flex-direction: column;
                    box-sizing: border-box;
                    padding: 50px 30px;
                    background: #ffffff;
                    margin-top: 30px;
                    border-radius: 8px;

                    .attach-item {
                        width: 100%;
                        box-sizing: border-box;
                        height: 40px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-top: 50px;

                        &:first-child {
                            margin-top: 0px;
                        }

                        .attach-name {
                            height: 16px;
                            font-size: 16px;
                            font-weight: 500;
                            color: #333333;
                            line-height: 16px;
                        }

                        .download-attach {
                            margin-left: 30px;
                            width: 104px;
                            height: 40px;
                            background: #3ca7fa;
                            border-radius: 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 16px;
                            font-weight: 400;
                            color: #ffffff;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>
